import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { num } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { LengthsEditor } from "@/components/materials/LengthsEditor";
import { sortedLengths } from "@/lib/zips";

// Giacenza di una cerniera: pezzi divisi per lunghezza
export const ZipStock = ({ m }) => {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const [lengths, setLengths] = useState(m.lengths || {});
  const save = useMutation({
    mutationFn: async () => (await api.patch(`/materials/${m.id}`, { lengths })).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["materials"] }); toast.success("Giacenza per lunghezza salvata"); setOpen(false); },
    onError: () => toast.error("Giacenza non salvata"),
  });
  const rows = sortedLengths(m.lengths);
  return (
    <>
      <button type="button" onClick={() => { setLengths(m.lengths || {}); setOpen(true); }} className="rounded px-2 py-1 text-center transition-colors hover:bg-secondary" title="Clicca per modificare i pezzi per lunghezza" data-testid={`mat-zip-${m.id}`}>
        <span className={`block font-semibold underline decoration-dotted underline-offset-4 ${m.quantity <= 0 ? "text-rose-400" : ""}`}>{num(m.quantity)} {m.unit}</span>
        <span className="block text-[11px] text-muted-foreground">{rows.length ? rows.map(([k, q]) => `${k} cm: ${num(q)}`).join(" · ") : "lunghezze da inserire"}</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`mat-zip-dialog-${m.id}`}>
          <DialogHeader>
            <DialogTitle>{m.name} · {m.color || "-"}</DialogTitle>
            <DialogDescription>Scrivi quanti pezzi hai per ogni lunghezza: il totale della giacenza si aggiorna da solo.</DialogDescription>
          </DialogHeader>
          <LengthsEditor value={lengths} onChange={setLengths} testid={`mat-zip-lengths-${m.id}`} />
          <DialogFooter><Button onClick={() => save.mutate()} disabled={save.isPending} data-testid={`mat-zip-save-${m.id}`}>Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
